<div *ngIf="loaderService.isLoading | async" class="global-loader-backdrop">
  <div class="citizex-spinner citizex-spinner--lg" role="status">
    <span class="sr-only">Please wait</span>
  </div>
</div>
